import { SystemProvider } from '@rahtab/system';
import React from 'react';
import Router from 'components/Router';
import { I18nManager, Image, StyleSheet, View, Platform } from 'react-native';
import { TokenAuthProvider } from '@rahtab/auth/lib/token-based-auth';
import { BASE_URL } from './src/services';
import { reducer } from './src/rahtab-redux/store';
import { getRadius, isStandalone, Text, Colors, getSpacing, getShadow } from '@rahtab/ui';
import Svg, { G, Path, Rect } from 'react-native-svg';

I18nManager.forceRTL(true);

export const url = `${BASE_URL}/dl/Rahtab/SupplierVetMobileApp.aspx`;

const iconImage = require('./assets/images/icon.png');

export default function App() {
  return (
    <SystemProvider reducers={reducer}>
      <TokenAuthProvider baseURL={url}>
        {!isStandalone() ? (
          <View style={styles.root}>
            <Image source={iconImage} style={styles.icon} />
            <View style={{ maxWidth: 500 }}>
              <Text style={styles.title} variant="title">
                نسخه وب ‌اپلیکیشن (PWA) ناظران رهتاب را به صفحه اصلی اضافه کنید
              </Text>
              <View style={styles.line}>
                <Text margin="none">
                  1. روی دکمه
                  <Text color="primary" variant="mediumBody" margin="none" children=" Share " />
                  در نوار پایین کلیک کنید.
                </Text>
                <Svg id="Group_820" data-name="Group 820" width={18} viewBox="0 0 11.955 16.877">
                  <Path
                    id="Path_4"
                    data-name="Path 4"
                    d="M-1992.74,524.715v.789h3.2v10.375h-10.375V525.5h3.2v-.789h-3.986v11.954h11.955V524.715Z"
                    transform="translate(2000.709 -519.791)"
                    fill="#1261d7"
                  />
                  <Path
                    id="Path_5"
                    data-name="Path 5"
                    d="M-1960.619,473.175v9.148h.79v-9.148l1.5,1.473.554-.563-2.446-2.406-2.446,2.406.554.563Z"
                    transform="translate(1966.201 -471.68)"
                    fill="#1261d7"
                  />
                </Svg>
              </View>
              <View style={styles.line}>
                <Text margin="none">
                  2. گزینه
                  <Text color="primary" variant="mediumBody" margin="none" children=" Add to Home Screen " />
                  را فعال کنید.
                </Text>
                <Svg width="17.067" height="17.067" viewBox="0 0 17.067 17.067">
                  <G id="Group_825" data-name="Group 825" transform="translate(792.399 -162.027)">
                    <Rect
                      id="Rectangle_238"
                      data-name="Rectangle 238"
                      width="17.067"
                      height="17.067"
                      rx="3"
                      transform="translate(-792.399 162.027)"
                      fill="#6a6971"
                    />
                    <Path
                      id="Path_6"
                      data-name="Path 6"
                      d="M-1972.088,932.344h-3.551v-3.551h-1.053v3.551h-3.551V933.4h3.551v3.551h1.053V933.4h3.551Z"
                      transform="translate(1192.299 -762.292)"
                      fill="#fff"
                    />
                  </G>
                </Svg>
              </View>
              <View style={styles.line}>
                <Text margin="none">
                  3. در قسمت بالا روی
                  <Text color="primary" variant="mediumBody" margin="none" children=" Add " />
                  کلیک کنید.
                </Text>
                <Svg width="18.269" height="7.438" viewBox="0 0 18.269 7.438">
                  <G id="Group_821" data-name="Group 821" transform="translate(0 0)">
                    <Path
                      id="Path_7"
                      data-name="Path 7"
                      d="M-2030.716,1357.966h-1.5l-2.506,7.074h1.434l.616-1.819h2.4l.617,1.819h1.435Zm-1.566,4.073.818-2.547.829,2.547Z"
                      transform="translate(2034.717 -1357.734)"
                      fill="#1261d7"
                    />
                    <Path
                      id="Path_8"
                      data-name="Path 8"
                      d="M-1958.595,1355.466v2.577a1.978,1.978,0,0,0-1.566-.688,2.515,2.515,0,0,0-2.506,2.78,2.572,2.572,0,0,0,2.587,2.769,2.055,2.055,0,0,0,1.566-.677v.545h1.314v-7.306Zm-1.314,6.2a1.367,1.367,0,0,1-1.354-1.526,1.393,1.393,0,0,1,1.354-1.556,1.379,1.379,0,0,1,1.355,1.556A1.388,1.388,0,0,1-1959.909,1361.671Z"
                      transform="translate(1969.356 -1355.466)"
                      fill="#1261d7"
                    />
                    <Path
                      id="Path_9"
                      data-name="Path 9"
                      d="M-1892.745,1355.466v2.577a1.978,1.978,0,0,0-1.566-.688,2.515,2.515,0,0,0-2.506,2.78,2.572,2.572,0,0,0,2.586,2.769,2.055,2.055,0,0,0,1.566-.677v.545h1.314v-7.306Zm-1.314,6.2a1.367,1.367,0,0,1-1.354-1.526,1.393,1.393,0,0,1,1.354-1.556,1.379,1.379,0,0,1,1.354,1.556A1.388,1.388,0,0,1-1894.059,1361.671Z"
                      transform="translate(1909.62 -1355.466)"
                      fill="#1261d7"
                    />
                  </G>
                </Svg>
              </View>
            </View>
          </View>
        ) : (
          <Router />
        )}
      </TokenAuthProvider>
    </SystemProvider>
  );
}

const styles = StyleSheet.create({
  root: {
    alignItems: 'center',
    backgroundColor: Colors.background,
    flex: 1,
    justifyContent: 'center',
    paddingHorizontal: getSpacing(2),
  },
  title: {
    marginBottom: getSpacing(4),
    textAlign: 'center',
  },
  icon: {
    height: 60,
    width: 60,
    borderRadius: getRadius(),
    marginBottom: getSpacing(4),
    ...getShadow(),
  },
  line: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: getSpacing(),
  },
});
